/**
 * Confirmation explicite énumérant ce qui sera perdu ou remplacé, et proposant
 * un export préalable lorsqu'un roadbook existe.
 */

import type { JSX } from 'preact';
import { exportRoadbook, pendingConfirmation } from '../state';

export function ConfirmationDialog(): JSX.Element | null {
  const request = pendingConfirmation.value;
  if (request === null) return null;

  const close = (): void => {
    pendingConfirmation.value = null;
  };

  return (
    <div class="modal-backdrop" role="dialog" aria-modal="true" aria-label={request.title}>
      <div class="modal">
        <h2 style="margin-top:0;">{request.title}</h2>
        <p>{request.body}</p>
        {request.detail !== undefined ? (
          <ul>
            {request.detail.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>
        ) : null}
        <div class="actions">
          {request.offerExport ? (
            <button
              type="button"
              onClick={() => {
                void exportRoadbook();
              }}
            >
              Exporter d’abord
            </button>
          ) : null}
          <button type="button" onClick={close}>
            Annuler
          </button>
          <button
            type="button"
            class="primary"
            onClick={() => {
              close();
              void request.onConfirm();
            }}
          >
            {request.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
